import React from "react"
import Paper from "@material-ui/core/Paper"
import { CalendarType } from "Types/channel"
import { useCalendarWrapStyles } from "./style"
import { useCalendar } from "./hook"
import PresetProvider from "./context"
import Calendar from "./Calendar"
export interface ComponentProps {
    calendarType: CalendarType,
}
export default function(props: ComponentProps) {
    const classes = useCalendarWrapStyles()
    const value = useCalendar()
    return (
        <PresetProvider value={value}>
            <Paper className={classes.root}>
                <Calendar />
            </Paper>
        </PresetProvider>
    )
}
